import React from "react";
import { Place, Role } from "../types";

interface RolesPageProps {
  placeDetail: Place | null;
  userRolesdetail: Role[] | undefined;
  setSelectedRoles: (roles: string[] | undefined) => void;
}

export default function RolesPage({
  placeDetail,
  userRolesdetail,
  setSelectedRoles,
}: RolesPageProps) {
  return (
    <div style={{ padding: 16 }}>
      <h2>Role</h2>
      <p>Funkcionalita rolí bude implementována </p>
    </div>
  );
}
